module.exports = __webpack_public_path__ + "media/Video 101.57482101.mp4";